import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as ImportIcon } from "../../../assets/icon/importIcon.svg";
import { ReactComponent as ImportCircleIcon } from "../../../assets/icon/importCircle.svg";

const IMPORT_CARDS = [
    {
        type: "checkin",
        title: "import_data.label.import_timestamp",
        description: "import_data.label.timeStamp_details",
    },
    {
        type: "accumulate",
        title: "import_data.label.import_annual_accumulate",
        description: "import_data.label.accumulate_details",
    },
    {
        type: "fund",
        title: "import_data.label.import_fund",
        description: "import_data.label.fund_details",
    },
];

const CompanyImportData = ({
    openModal = () => { },
    CompanyImportModal = () => { },
}) => {
    const { t } = useTranslation();

    return (
        <MainLayout>
            {CompanyImportModal()}

            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("masterdata.header"), href: "" },
                        { title: t("import_data.header") },
                    ]} />
                    <h2>{t("import_data.header")}</h2>
                </Flex>

                <Row gutter={[16, 16]} align="stretch">
                    {IMPORT_CARDS.map(({ type, title, description }) => (
                        <Col key={type} span={12}>
                            <Card style={{ border: "1px solid #D9D9D9", borderRadius: "8px", height: "100%" }}>
                                <Flex gap={16} align="flex-start">
                                    <ImportCircleIcon width={42} style={{ flexShrink: 0 }} />
                                    <Flex vertical justify="space-between" gap={40}>
                                        <Flex vertical>
                                            <span style={{ color: "#313131", fontSize: "16px" }}>{t(title)}</span>
                                            <span style={{ color: "#667085" }}>{t(description)}</span>
                                        </Flex>
                                        <Button
                                            type="default"
                                            size="large"
                                            style={{ alignSelf: "flex-start" }}
                                            onClick={() => openModal(type)}
                                        >
                                            <Flex gap={8}>
                                                <ImportIcon />
                                                <span style={{ color: "#59687F" }}>{t("common.import")}</span>
                                            </Flex>
                                        </Button>
                                    </Flex>
                                </Flex>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Space>
        </MainLayout>
    );
};

export default CompanyImportData;